import React, { useEffect } from 'react';
import { Redirect, Route, Switch } from 'react-router-dom';
import { routes } from './routes';
import { useEnterPage, useTea } from '@utils/index';
import User from '@containers/user';
import { initMonitor } from '@utils/monitor';
import { changeDayjsLocale } from '@utils/day';
import { LangCode } from '@common/lang';
import { useTranslation } from '@ies/intl-react-plugin';
import { ConfigProvider } from '@byted/serial-components-i18n';
import { checkWebId } from '@containers/account/ttwid';
import { useDebugger } from '@utils/debugger';
import { initCsrf } from '@utils/csrf';

import '@static/style/public.less';
import './index.less';
import useLocationOff from '@components/location-off';

initCsrf();
initMonitor(true);

// 不能将让 process.env.NODE_ENV === 'development' 等判断从其他文件引入，否则 tree-shaking 会失效
const Inspector = process.env.NODE_ENV !== 'production' ? require('react-dev-inspector').Inspector : null;

const App: React.FC = () => {
    const { i18n } = useTranslation();
    const { LocationOff, isOff } = useLocationOff();
    useDebugger();
    useTea(true);
    useEnterPage();

    useEffect(() => {
        checkWebId();
    }, []);

    useEffect(() => {
        changeDayjsLocale(i18n.language as LangCode);
    }, [i18n.language]);

    const app = (
        <ConfigProvider lang={i18n.language as any}>
            <User />
            <Switch>
                {routes.map((route, index) => (
                    <Route {...route} key={index} />
                ))}
                <Redirect from="/*" to="/" />
            </Switch>
        </ConfigProvider>
    );

    if (isOff) {
        return <LocationOff />;
    }

    if (Inspector) {
        return (
            <>
                <Inspector keys={['Command', 'Shift', 'S']} />
                {app}
            </>
        );
    }

    return app;
};

export default App;
